import React from "react";
import { format, subDays } from "date-fns";
const WEEKS = 20;
const shades = ["bg-sunken", "bg-brand-tint", "bg-brand/60", "bg-brand"];

// Deterministic pseudo-activity so the prototype looks lived-in.
function intensity(i: number): number {
  const v = Math.sin(i * 12.9898) * 43758.5453;
  const r = v - Math.floor(v);
  if (i > WEEKS * 7 - 13) return r > 0.2 ? 3 : 2;
  return r < 0.28 ? 0 : r < 0.55 ? 1 : r < 0.82 ? 2 : 3;
}
export function ActivityHeatmap() {
  const today = new Date();
  const total = WEEKS * 7;
  const days = Array.from({
    length: total
  }, (_, i) => ({
    date: subDays(today, total - 1 - i),
    level: intensity(i)
  }));
  const activeDays = days.filter(d => d.level > 0).length;
  return <div data-id="element-1101" data-mp="2uqdwmp0oatp7">
      <div className="no-scrollbar overflow-x-auto" data-id="element-1102" data-mp="2uqvyq2a0o251">
        <div className="grid w-max grid-flow-col grid-rows-7 gap-1" role="img" aria-label={`${activeDays} active days in the last ${WEEKS} weeks`} data-id="element-1103" data-mp="2zra5zi3sn820">
          {days.map((d, i) => <span key={i} title={`${format(d.date, "MMM d")}${d.level ? "" : " · no practice"}`} className={`h-3.5 w-3.5 rounded-[4px] border border-line/25 ${shades[d.level]}`} data-id="element-1104" data-mp="33uj8u6hn9hwo" data-mpi={i} />)}
        </div>
      </div>
      <div className="mt-3 flex items-center justify-between text-xs text-ink-2" data-id="element-1105" data-mp="2uw78vduw17rk">
        <span data-id="element-1106" data-mp="2pwkxzb2j83lx">{activeDays} active days</span>
        <span className="flex items-center gap-1" data-id="element-1107" data-mp="3ml0z84f081ev">
          Less
          {shades.map(s => <span key={s} className={`h-3 w-3 rounded-[3px] border border-line/25 ${s}`} data-id="element-1108" data-mp="3ijxk5k4s69ep" />)}
          More
        </span>
      </div>
    </div>;
}